<template>
  <div class="flex-group" style="border-bottom: 1px solid grey;padding: 10px;font-size: 14px;">
    <div class="item" style="flex: 1; margin-right: 20px;text-align: left;">
      <p class="txt-bold">
        返水金额：{{ SafeItem.money
        }}<span style="float: right; color: #999">{{ SafeItem.created_at }}</span>
      </p>
      <p class="payType">
        {{ SafeItem.gamename }}
      </p>
      <p>领取时间：{{ SafeItem.state == 0 ? '暂未领取' : SafeItem.updated_at }}</p>
    </div>
    <div class="item">
      <p class="status">{{ SafeItem.state == 0 ? '待领取' : '已领取' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FanShuiItemView',
  props: ['item'],
  computed: {
    SafeItem () {
      return this.item || {}
    }
  },
}
</script>

<style></style>
